export default "__VITE_ASSET__CGJFUayl__"